module.exports = __webpack_public_path__ + "img/icon-scene5.b64ec19c.jpg";